import { GETFANCYLIST, SMBETSOFUSER, SMEVENTMARKETLIST, SMEVENTSAVE, SMGETBOOK, SMMARKETLIST, SMSETDELETERESULT, SMSETEVENTSTATUS, SMSETRESULT, UPDATEFANCYLIST } from './url'
import axios from 'axios';

class FancyServiceClass {

    async GetSMEventMarketListService(marketid) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMEVENTMARKETLIST}`, {
            headers: headers,
        });
    }

    async postSMEventSaveService(data) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`
        };
        return await axios.post(`${SMEVENTSAVE}`, data, {
            headers: headers,
        });
    }

    async GetSMMarketListService(isOpen) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMMARKETLIST}?IsOpen=${isOpen}`, {
            headers: headers,
        });
    }

    async GetSMMBetsOfUserService(marketId, uid) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMBETSOFUSER}?marketId=${marketId}&uid=${encodeURIComponent(uid)}`, {
            headers: headers,
        });
    }

    
    async GetSMSetResultService(data) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMSETRESULT}?marketId=${data.marketId}&result=${data.resultNo}`, {
            headers: headers,
        });
    }

    async SetSMDeleteResultService(marketId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMSETDELETERESULT}?marketId=${marketId}`, {
            headers: headers,
        });
    }

    async SetSMEventStatusService(eventId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMSETEVENTSTATUS}?eventid=${eventId}`, {
            headers: headers,
        });
    }
    async getSMBookService(marketId) {
        let logindata = JSON.parse(localStorage.getItem("loginUserDetails"))
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${logindata?.Token}`

        };
        return await axios.get(`${SMGETBOOK}?marketId=${marketId}`, {
            headers: headers,
        });
    }

}

const FancyService = new FancyServiceClass()

export default FancyService;